import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Footer from './components/Footer';
import LanguageGate from './components/LanguageGate';
import Nav from './components/Nav';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminPage from './pages/AdminPage';
import BookingPage from './pages/BookingPage';
import GalleryAccessPage from './pages/GalleryAccessPage';
import GalleryPage from './pages/GalleryPage';
import HomePage from './pages/HomePage';
import LegalPage from './pages/LegalPage';

function Shell() {
  const location = useLocation(); const adminDashboard = location.pathname.startsWith('/admin/dashboard'); const galleryView = /^\/gallery\/[^/]+/.test(location.pathname);
  return <><LanguageGate />{!adminDashboard && !galleryView && <Nav />}<Routes><Route path="/" element={<HomePage/>}/><Route path="/gallery" element={<GalleryAccessPage/>}/><Route path="/gallery/:galleryId" element={<GalleryPage/>}/><Route path="/book" element={<BookingPage/>}/><Route path="/admin" element={<AdminLoginPage/>}/><Route path="/admin/dashboard" element={<AdminPage/>}/><Route path="/privacy" element={<LegalPage type="privacy"/>}/><Route path="/terms" element={<LegalPage type="terms"/>}/></Routes>{!adminDashboard && !galleryView && <Footer />}</>;
}
export default function App(){return <BrowserRouter><Shell/></BrowserRouter>}
